export default [
  {
    name: 'Kent C. Dodds',
    title: 'Workshop Creation and Instruction',
    description:
      "Kent designed, created and recorded all the material for Epic React to teach you everything he knows about React in a clear, path-driven way. He's rigorously tested the content in a series of live workshops and revised it based on feedback from learners.",
    link: {url: 'https://x.com/kentcdodds', label: 'Twitter'},
    avatar: '/kent-c-dodds.jpg',
  },
  {
    name: 'Joel Hooks',
    title: 'Executive Producer',
    description:
      'Joel managed and coordinated the production of Epic React, working closely with Kent from conception to implementation as well as serving as technical architect and lead developer for the custom courseware that drives the course.',
    link: {url: 'https://x.com/jhooks', label: 'Twitter'},
    avatar: '/joel-hooks.jpg',
  },
  // {
  //   name: 'Maggie Appleton',
  //   title: 'Art Direction',
  //   description:
  //     'Maggie translated the concepts taught in Epic React into the space-themed metaphors and provided a cohesive creative vision for the beautiful illustration work.',
  //   link: {url: 'https://x.com/mappletons', label: 'Twitter'},
  //   avatar: '/maggie-appleton.jpg',
  // },
  {
    name: 'Vojta Holik',
    title: 'UI/UX Design & Development',
    description:
      'As product designer/developer, Vojta handled the UI/UX design and development of Epic React.',
    link: {url: 'https://x.com/vojta_holik', label: 'Twitter'},
    avatar: '/vojta-holik.jpg',
  },
  {
    name: 'Nicoll Guarnizo',
    title: 'Associate Producer',
    description:
      'Nicoll lead the content migration into the course infrastructure and did QA reviews to identify fixes needed ahead of launch. She also provided platform development support.',
    link: {url: 'https://x.com/guarnizonicoll', label: 'Twitter'},
    avatar: '/nicoll-guarnizo.jpg',
  },
  {
    name: 'Zac Jones',
    title: 'Content Production and Review',
    description:
      'Zac did UX testing on the workshop modules — reviewing them for any quality control issues and ensuring the workflow of each makes sense for learners.',
    link: {url: 'https://x.com/zacjones93', label: 'Twitter'},
    avatar: '/zac-jones.jpg',
  },
  {
    name: 'Haze Provinsal',
    title: 'Content Production and Review',
    description:
      'Haze did all video editing for each of the 350 lessons to ensure a smooth viewing experience.',
    link: {url: 'https://x.com/HazeProvinsal', label: 'Twitter'},
    avatar: '/haze-provinsal.jpg',
  },
  {
    name: 'Taylor Bell',
    title: 'Learning Design Support',
    description:
      'Taylor worked with Kent during the workshop design process to help define the learner outcomes and concepts that would be taught in each of the modules, as well as the plan to achieve those outcomes.',
    link: {url: 'https://x.com/taylorbell', label: 'Twitter'},
    avatar: '/taylor-bell.jpg',
  },
  {
    name: 'Ian Jones',
    title: 'Back-End Development / Infrastructure',
    description:
      "Ian did the back-end development to build Epic React as a standalone product using Gatsby and MDX for this massive workshop, using egghead's infrastructure as the CMS.",
    link: {url: 'https://x.com/_jonesian', label: 'Twitter'},
    avatar: '/ian-jones.jpg',
  },
  {
    name: 'Yevhen Nahalskyi',
    title: 'UI/UX Development',
    description:
      'Yevhen contributed to the front-end development with his CSS wizardry.',
    link: {url: 'https://x.com/nahalskyi', label: 'Twitter'},
    avatar: '/yevhen-nahalskyi.jpg',
  },

  {
    name: 'Lucas Minter',
    title: 'Content Production and Review',
    description:
      'Lucas reviewed the edited lessons to identify any quality issues that needed fixing and reviewed accompanying transcripts for accuracy.',
    link: {url: 'https://x.com/lucasminter', label: 'Twitter'},
    avatar: '/lucas-minter.jpg',
  },
  {
    name: 'Cree Provinsal',
    title: 'Content Production and Review',
    description:
      'Cree reviewed and edited lesson transcripts to ensure they were accurate and matched up with the lessons.',
    link: {url: 'https://x.com/cprovinsal', label: 'Twitter'},
    avatar: '/cree-provinsal.jpg',
  },
  {
    name: 'Lauro Silva',
    title: 'Content Production and Review',
    description:
      "Lauro did UX testing on the workshop's models, reviewed lesson transcripts, and helped with coordinating the content review efforts.",
    link: {url: 'https://x.com/laurosilvacom', label: 'Twitter'},
    avatar: '/lauro-silva.jpg',
  },

  {
    name: 'Maxime Bourgeois',
    title: 'Illustration',
    description:
      'Maxime is responsible for creating the delightful  illustrations used throughout Epic React.',
    link: {url: 'https://x.com/maximalgfx', label: 'Twitter'},
    avatar: '/maxime-bourgeois.jpg',
  },
  // {
  //   name: 'Gustavo Henrique',
  //   title: 'Illustration',
  //   description:
  //     'Gustavo is responsible for creating the delightful 3D illustrations used throughout Epic React.',
  //   link: {url: 'https://dribbble.com/guutv', label: 'Dribbble'},
  //   avatar: '/gustavo-henrique.jpg',
  // },
  // {
  //   name: 'David Gil',
  //   title: 'Illustration',
  //   description:
  //     'David is responsible for creating the delightful 3D illustrations used throughout Epic React.',
  //   // link: { url: 'https://sariselka.com',label: "Personal Site" },
  //   avatar: '/david-gil.jpg',
  // },
]
